import Vue from "vue";

Vue.config.productionTip = false;

// TODO: move it to autoload
import FAQ from "@/components/page/FAQ";
import Map from "@/components/page/Map";
import Card from "@/components/page/Card";
import Carousel from "@/components/page/Carousel";
import Collection from "@/components/page/Collection";
import CurrentReservation from "@/components/common/CurrentReservation";

Vue.component("FAQ", FAQ);
Vue.component("Map", Map);
Vue.component("Card", Card);
Vue.component("Carousel", Carousel);
Vue.component("Collection", Collection);
Vue.component("CurrentReservation", CurrentReservation);

import VueFormulate from "@braid/vue-formulate";

import Classes from "@/core/formulate/classes";
import Validation from "@/core/formulate/validation";
import FileUploader from "@/core/formulate/file-uploader";
import CustomInputs from "@/core/formulate/custom-inputs";

Vue.use(VueFormulate, {
    plugins: [Classes, Validation, FileUploader, CustomInputs],
    locales: {
        en: {
            minMaxTime({ args }) {
                const min = args[0];
                const max = args[1];

                if (min !== 'null' && max !== 'null') {
                    return `Please select a time between ${min} and ${max}`;
                } else if (min !== 'null') {
                    return `Please select a time after ${min}`;
                } else if (max !== 'null') {
                    return `Please select a time before ${max}`;
                }
            }
        }
    }
});

import VueBreadcrumbs from "vue-2-breadcrumbs";
import Breadcrumbs from "@/components/common/Breadcrumbs";

Vue.use(VueBreadcrumbs, Breadcrumbs);

import "@/styles/main.css";

import App from "@/App.vue";
import store from "@/store";
import i18n from "@/core/i18n";
import router from "@/core/router";

import {
    DrSettings,
    DrWebMessenger,
    DrPermissions,
    DrPusher,
    DrUtils
} from "@/plugins";

Vue.use(DrUtils);
Vue.use(DrSettings, {
    store,
    store_path: "app/settings"
});
Vue.use(DrPermissions, {
    store,
    store_path: "permissions/permissions"
});
Vue.use(DrWebMessenger, {});

store
    .dispatch("auth/authWithSignature", window.location.search)
    .then(() => {
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname + window.location.hash
        );
    })
    .finally(() => {
        store
            .dispatch("auth/fetchUser")
            .then(() => store.dispatch("app/fetchSidebar"))
            .then(() => store.dispatch("app/fetchSettings"))
            .then(() => store.dispatch("permissions/fetch"))
            .then(() => {
                Vue.use(DrPusher, {
                    user_uuid: store.getters["auth/user"].uuid
                });
            })
            .finally(() => {
                const app = new Vue({
                    i18n,
                    router,
                    store,
                    render: h => h(App),
                    components: {}
                });

                app.$mount("#app");
            });
    });
